import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const santander = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Santander Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>{{organization}}<br>Rückgabe-Buchung</strong>",
      },
      layout: {
        backText: "Zurück zu santander.de",
      },
      linkToHome: "https://www.santander.de/",
      contact: {
        ...de_DE_formal.translation.contact,
        text: "Haben Sie Fragen zur Buchung?",
        reachability: "",
        email: {
          label: "E-Mail",
          link: "mailto:logistik@santander-leasing.de",
          title: "logistik@santander-leasing.de",
        },
        phone: {
          label: "Telefon",
          link: "tel:004921619060374",
          title: "02161 - 90 60 374",
        },
      },
      benefits: {
        title: "Ihre Vorteile",
        "bullet-point-1": "Freie Termine direkt online buchen",
        "bullet-point-2": "",
        "bullet-point-3": "",
        feedbackText:
          "Sie haben Anregungen oder etwas funktioniert nicht wie erwartet? Wir würden es gerne erfahren.",
        feedbackTitle: "Feedback",
      },
      garageList: {
        ...de_DE_formal.translation.garageList,
        emptyState: {
          headline: "Sie haben keinen Standort in Ihrer Nähe gefunden?",
          description:
            "Tipp: Nutzen Sie den Regler auf der linken Seite, um die maximale Entfernung zu erhöhen – oft werden so weitere Rückgabestationen sichtbar. \n" +
            " Sollte dennoch kein passender Standort in Ihrer Nähe angezeigt werden oder die Entfernung zu groß sein, wenden Sie sich bitte direkt an Ihren Leasinggeber, um das weitere Vorgehen zu klären.",
          "bullet-point-1": "",
          "bullet-point-2": "",
        },
      },
      hotline: {
        "hotline-headline": "Santander Leasing Support",
        "hotline-phone-link": "tel:004921619060374",
        "hotline-phone": "+49 2161 - 90 60 374",
        "hotline-availability": "",
        "hotline-via-email": "Erfrage Termine alternativ auch gern per Mail an: ",
        "hotline-via-email-email": "logistik@santander-leasing.de",
      },
    },
  },
};
